module.exports = __webpack_public_path__ + "img/Our_work_3.b4e7bac1.png";